import { render } from "./BindAlipay.vue?vue&type=template&id=4a60c3d4&scoped=true"
import script from "./BindAlipay.vue?vue&type=script&lang=js"
export * from "./BindAlipay.vue?vue&type=script&lang=js"

import "./BindAlipay.vue?vue&type=style&index=0&id=4a60c3d4&scoped=true&lang=css"

import exportComponent from "C:\\chuning\\cn-page\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a60c3d4"]])

export default __exports__